import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';

import { dvrPageTestIDs, Theme } from '@constants';

import { tPath } from './constatns';

export const DVRPage = () => {
  const { t } = useTranslation();

  return (
    <View style={Theme.styles.right}>
      <View style={Theme.styles.header}>
        <Text style={Theme.styles.headerText} testID={dvrPageTestIDs.header}>
          {t(`${tPath}title`)}
        </Text>
      </View>
      <View>
        <Text>{t(`${tPath}body`)}</Text>
      </View>
    </View>
  );
};
